import React, { useState, useEffect } from "react";
import { Reveal, Overline } from "./Reveal";
import { TESTIMONIALS } from "@/data/content";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

export function Testimonials() {
  const [i, setI] = useState(0);
  const next = () => setI((p) => (p + 1) % TESTIMONIALS.length);
  const prev = () => setI((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, []);

  const t = TESTIMONIALS[i];

  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <Overline>What People Say</Overline>
          <Quote className="text-epic-gold mx-auto mt-8" size={48} />
          <blockquote
            key={i}
            data-testid="testimonial-quote"
            className="font-display text-3xl md:text-5xl text-white leading-tight mt-6 animate-fade-up"
          >
            "{t.quote}"
          </blockquote>
          <div className="mt-8">
            <p className="text-epic-gold uppercase tracking-[0.2em] text-sm font-semibold">{t.author}</p>
            <p className="text-white/50 text-sm mt-1">{t.role}</p>
          </div>
        </Reveal>

        <div className="flex items-center justify-center gap-4 mt-10">
          <button data-testid="testimonial-prev" onClick={prev} className="p-3 border border-white/15 text-white hover:border-epic-gold hover:text-epic-gold transition-colors">
            <ChevronLeft size={20} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((item, idx) => (
              <span key={item.author} className={`h-1.5 w-1.5 rounded-full ${idx === i ? "bg-epic-gold" : "bg-white/25"}`} />
            ))}
          </div>
          <button data-testid="testimonial-next" onClick={next} className="p-3 border border-white/15 text-white hover:border-epic-gold hover:text-epic-gold transition-colors">
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
}
